import { AuthService } from "../services/AuthService.js";
import { AppConfig } from "../config/AppConfig.js";
import { ApiService } from "../services/ApiService.js";
import { TemplateEngine } from "../utils/TemplateEngine.js";
import { DashboardController } from "../../dashboard/DashboardController.js";
import { SupportDialog } from "./SupportDialog.js";
import navbarTemplate from "../templates/navbar.html?raw";

export const Navbar = {
	render: async () => {
		const user = AuthService.getCurrentUser();

		const notifications = await ApiService.post("apiapp/Notificaciones", null, user?.token);
		const notifList = Array.isArray(notifications?.message) ? notifications.message : [];

		const data = {
			logoUrl: AppConfig.external.logoUrl,
			appName: AppConfig.app.name,
			appVersion: AppConfig.app.version,
			userName: user?.nombre || "Usuario",
			showNotifications: AppConfig.features.notifications,
			notificationCount: `${notifList.filter((n) => !n.read).length}`,
			isDevelopment: AppConfig.isDevelopment(),
		};

		const html = TemplateEngine.render(navbarTemplate, data);

		// Configurar eventos después de que el DOM se actualice
		setTimeout(() => {
			const logoutBtn = document.getElementById("logoutBtn");
			if (logoutBtn && !logoutBtn.hasAttribute("data-listener-added")) {
				logoutBtn.addEventListener("click", (e) => {
					e.preventDefault();
					AuthService.logout();
				});

				document.querySelector('#lnkNotifications').addEventListener("click", (e) => {
					e.preventDefault();
					DashboardController.showNotifications();
				});

				document.getElementById("lnkSupport")?.addEventListener("click", (e) => {
					e.preventDefault();
					SupportDialog.open();
				});

				logoutBtn.setAttribute("data-listener-added", "true");
			}
		}, 10);



		return html;
	},
};
